import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiArrowRight } = FiIcons;

const Contact = () => (
  <>
    <Helmet>
      <title>Contact KCG | Kabod Care Group</title>
      <meta name="description" content="Contact KCG about home care and support. Call 03333 394 077 or email enquiries@odaracare.org.uk while our new email addresses are being set up." />
      <link rel="canonical" href="https://kcg.care/contact" />
    </Helmet>
    <section className="bg-gradient-to-br from-primary-50 to-secondary-50 py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-primary-900 font-semibold mb-4">KCG · Kabod Care Group</p>
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">Get in touch</h1>
        <p className="text-xl text-gray-700 leading-relaxed">Tell us where care is needed and what support you are looking for. We can discuss the next steps with you.</p>
      </div>
    </section>
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-8">
        <a href="tel:03333394077" className="rounded-2xl border border-primary-100 bg-primary-50 p-8 hover:shadow-lg transition-shadow">
          <SafeIcon icon={FiPhone} className="w-9 h-9 text-primary-900 mb-5" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Call us</h2>
          <p className="text-lg text-primary-900 font-semibold">03333 394 077</p>
          <p className="text-gray-600 mt-3">For urgent medical help, call NHS 111 or 999 as appropriate.</p>
        </a>
        <a href="mailto:enquiries@odaracare.org.uk" className="rounded-2xl border border-primary-100 bg-primary-50 p-8 hover:shadow-lg transition-shadow">
          <SafeIcon icon={FiMail} className="w-9 h-9 text-primary-900 mb-5" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Email us</h2>
          <p className="text-lg text-primary-900 font-semibold break-all">enquiries@odaracare.org.uk</p>
          <p className="text-gray-600 mt-3">Our existing email address remains in use during the KCG transition. Please do not include detailed medical information in an initial enquiry.</p>
        </a>
      </div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <Link to="/where-we-operate" className="inline-flex items-center text-primary-900 font-semibold hover:underline">Check where we operate <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" /></Link>
      </div>
    </section>
  </>
);

export default Contact;
